import RouterWrapper from './RouterWrapper'

export function App() {
  return <RouterWrapper />
}

export default App
